import React, {useCallback, useMemo, useRef} from 'react';
import {CONTENT_TYPES} from "@/constants";
import {getLinkData} from "@/components/common/Links/utils";
import Header from "@/components/Menu/Shared/Header";
import {useStageContext} from "@/components/Menu/Mobile/Stages";
import {getPropSafely} from "@/utils/utils";
import NewsletterModalAction
	from "@/components/common/StructuredText/components/Blocks/BulletPointsWithActions/ActionsVariants/NewsletterModalAction";
import Text from "@/components/common/Text";

const Category = ({data, ...props}) => {
	const {stage, setStage, setItem} = useStageContext()
	const {
		text,
		url,
		items,
		openNewsletter
	} = useMemo(() => {
		const items = data?.children || []
		const isMenuRecord = data?.__typename === CONTENT_TYPES.MENU
		const source = isMenuRecord ? data?.universalLink : data
		const {text, url} = getLinkData(source)
		const openNewsletter = getPropSafely(data, 'openNewsletter', false)

		// logTable({
		// 	text,
		// 	url
		// })
		return ({
			text,
			url,
			items,
			openNewsletter
		})
	}, [data])

	const isExpandable = useMemo(() => {
		return items?.length > 0 && stage === 0
	}, [stage, items])
	const newsletterActionRef = useRef();

	const onHeaderClick = useCallback(() => {
		setItem(data)
		setStage(1)
	}, [setItem, setStage, data])


	const handleSingleHeaderClick = () => {
		if (!openNewsletter) return

		if (newsletterActionRef.current && newsletterActionRef.current.handleModalOpen) {
			newsletterActionRef.current.handleModalOpen();
		}
	}

	return isExpandable ? (
		<Header color='periwinkle' arrow square={false} onClick={onHeaderClick}>
			{text}
		</Header>
	) : (
		<>
			{openNewsletter && (
				<NewsletterModalAction
					showButton={false}
					ref={newsletterActionRef}
				/>
			)}
			<Header
				color='periwinkle'
				isLink={!openNewsletter}
				url={url}
				square={false}
				onClick={handleSingleHeaderClick}
			>
				{text}
			</Header>
		</>
	)
};

export default Category;
